module.exports = __webpack_public_path__ + "img/be61731.png";